module.exports = __webpack_public_path__ + "img/activity1.8b0f1b22.png";